import React, { useState, useEffect } from "react";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { GoTrash, GoPlus } from "react-icons/go";
import x from "../../../../utils/Icons/X.svg";

export const UserFlows = ({ data, setData }) => {
  const [flows, setFlows] = useState(data.userFlows || []); // Initialize with data from parent

  useEffect(() => {
    setData(prevData => ({ ...prevData, userFlows: flows }));
  }, [flows, setData]);

  const handleImageUpload = (e, index) => {
    if (e.target.files && e.target.files[0]) {
      const updatedFlows = [...flows];
      updatedFlows[index].image = URL.createObjectURL(e.target.files[0]);
      setFlows(updatedFlows);
    }
  };

  const removeImage = (index) => {
    const updatedFlows = [...flows];
    updatedFlows[index].image = null;
    setFlows(updatedFlows);
  };

  const addFlow = () => {
    setFlows([...flows, { flowName: "", image: null }]);
  };

  const deleteFlow = (index) => {
    setFlows(flows.filter((_, i) => i !== index));
  };

  const handleFlowNameChange = (e, index) => {
    const updatedFlows = [...flows];
    updatedFlows[index].flowName = e.target.value;
    setFlows(updatedFlows);
  };

  return (
    <div className="bg-[#F0F0F0] dark:bg-[#282828] p-4 rounded-lg my-4">
      <div className="flex items-center space-x-2">
        <div className="bg-[#FFF0CF] w-4 h-4 rounded-lg" />
        <h1>User Flows (All-Screens Preview)</h1>
      </div>

      {flows.length === 0 ? (
        <div className="border-[1px] border-dashed text-center p-4 rounded-lg my-4 border-gray-600">
          <p>
            User flows are very effective for customers as they demonstrate how
            the application functions.{" "}
            <span className="underline">See Example</span>
          </p>
          <p className="opacity-60">No flows added. Add your first one</p>
          <div className="relative flex justify-center items-center space-x-8 my-4">
            <button
              className="bg-white cursor-pointer text-black px-4 py-2 rounded "
              onClick={addFlow}
            >
              + Add Flow
            </button>
          </div>
        </div>
      ) : (
        <>
          <p className="py-2">
            User flows are very effective for customers as they demonstrate how
            the application functions.{" "}
            <span className="underline">See Example</span>
          </p>
          {flows.map((flow, index) => (
            <div key={index} className="mb-4">
              <h1 className="py-2">Flow Name</h1>
              <div className="md:flex md:justify-between md:items-center md:space-x-2">
                <div className="flex w-full items-center space-x-2 border bg-white dark:bg-[#1c1c1c] dark:border-[#5B5B5B] rounded-lg p-3">
                  <HiOutlineMenuAlt4 />
                  <input
                    className="w-full bg-transparent"
                    type="text"
                    placeholder="e.g. onboarding, account settings, checkout..."
                    value={flow.flowName}
                    onChange={(e) => handleFlowNameChange(e, index)}
                  />
                </div>

                <div className="shrink-0 relative flex justify-between md:justify-center items-center space-x-4 my-4">
                  <div className="flex items-center space-x-4">
                    <div className="relative w-fit rounded-lg">
                      {flow.image ? (
                        <>
                          <img
                            className="w-[58px] h-[46px] rounded-lg"
                            src={flow.image}
                            alt="Flow preview"
                          />
                          <div
                            className="bg-[#E85959] absolute p-1.5 -top-2 -right-3 w-5 h-5 rounded-full flex items-center justify-center cursor-pointer"
                            onClick={() => removeImage(index)}
                          >
                            <img src={x} alt="Remove" />
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="relative">
                      <button className="border-[1px] py-3 border-[#1c1c1c] text-[#1c1c1c] dark:border-white dark:text-white flex items-center cursor-pointer px-4 rounded-lg ">
                        Upload Image{" "}
                        <span className="ml-1 border rounded-full w-2 h-2 p-2 text-xs flex items-center justify-center">
                          ?
                        </span>
                      </button>
                      <input
                        className="w-full cursor-pointer absolute top-0 opacity-0 border dark:border-[#5B5B5B]"
                        type="file"
                        onChange={(e) => handleImageUpload(e, index)}
                      />
                    </div>
                  </div>
                  <div
                    onClick={() => deleteFlow(index)}
                    className="border-[1px] text-[#F08383] border-[#F08383] flex-shrink-0 space-x-2 flex items-center py-3 px-3 rounded-lg"
                  >
                    <GoTrash />
                    <p className="hidden md:block">Delete Flow</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div
            className="bg-white flex items-center justify-center text-black w-full py-[11px] rounded-lg cursor-pointer"
            onClick={addFlow}
          >
            <GoPlus className="text-2xl" />
            <p>Add</p>
          </div>
        </>
      )}
    </div>
  );
};
